export const MSK_REGION_ID = '019e3e0d-3589-7143-837f-aed104fd9584'

export const useCommonStore = defineStore('common', () => {
  const directoryStore = useDirectoryStore()
  const currentRegion = computed(() => {
    if (!directoryStore.regions) return undefined
    return (
      directoryStore.regions.find((region) => region.id === MSK_REGION_ID) ||
      directoryStore.regions[0]
    )
  })
  const currentRegionId = computed(
    () => currentRegion.value?.id || MSK_REGION_ID,
  )

  return {
    currentRegion,
    currentRegionId,
  }
})
